import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let provisionaldetailPageMachine: any;

export const useSMProvisionalDetailPage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  provisionaldetailPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(provisionaldetailPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    provisionaldetailPageMachine,
    provisionaldetailPageState: state,
    provisionaldetailPageSend: send,
  };
};
